import { attr, belongsTo, hasMany } from '@ember-data/model';
import ShModel from './sh-model';

export const PLACEHOLDER_CLOUD_ID = 'web/spacer';

class Image extends ShModel {
  @attr cloudId;
  @attr('number') cloudVersion;
  @attr rank;
  @attr('number') width;
  @attr('number') height;
  @attr('string') type;

  @belongsTo('imageTransformList', { async: false }) transforms;
  @belongsTo('project', { async: false }) project;
  @belongsTo('user', { async: false, inverse: null }) user;
  @hasMany('activityFeedItem', { async: false, inverse: 'otherUserImage' }) activityFeedItem;

  get isPlaceholderImage() {
    return PLACEHOLDER_CLOUD_ID === this.cloudId;
  }
}

export default Image;
